import * as React from "react";
import {IconProps} from "@components/Icons/IconTypes";

export const ChevronUpIcon = React.forwardRef<SVGSVGElement, IconProps>(
    ({ size = 16, title, ...props }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 13 8"
                width={size}
                height={size}
                fill="none"
                role="img"
                aria-hidden={title ? undefined : true}
                {...props}
            >
                {title && <title>{title}</title>}
                <path
                    fill="currentColor"
                    d="M6.0636.14a.6253.6253 0 0 1 .8366.0432l5.8333 5.8333.0431.0472a.6253.6253 0 0 1-.0431.8366.6253.6253 0 0 1-.8366.0432l-.0472-.0432L6.4583 1.509 1.0669 6.9003a.6249.6249 0 1 1-.8838-.8838L6.0164.1832l.0472-.0431Z"
                />
            </svg>
        );
    }
);

ChevronUpIcon.displayName = "ChevronUpIcon";
